// Tiny gated-logging helpers. The `if (viewer.sceneMeta.debugEnabled)` guard
// is used in ~25 sites; these collapse it to one call so the gate, console
// channel, and prefix can be tweaked in one place.
//
// Use debugLog/debugWarn for diagnostic noise that should disappear in prod.
// Use debugError ONLY when the error is non-fatal AND a user-facing fallback
// fires elsewhere (alert, UI badge). Real errors should stay as plain
// console.error so they're always visible in DevTools.

interface ViewerWithDebug {
  sceneMeta?: { debugEnabled?: boolean };
}

export function debugLog(viewer: ViewerWithDebug | null | undefined, ...args: unknown[]): void {
  if (viewer && viewer.sceneMeta && viewer.sceneMeta.debugEnabled) {
    console.log(...args);
  }
}

export function debugWarn(viewer: ViewerWithDebug | null | undefined, ...args: unknown[]): void {
  if (viewer && viewer.sceneMeta && viewer.sceneMeta.debugEnabled) {
    console.warn(...args);
  }
}

export function debugError(viewer: ViewerWithDebug | null | undefined, ...args: unknown[]): void {
  if (viewer && viewer.sceneMeta && viewer.sceneMeta.debugEnabled) {
    console.error(...args);
  }
}
